define(function(require, exports, module) {
    'use strict';

    const i18n = require('i18n');

    const tKey = 'playtech.mobile.system.limits.setDepositLimitsError';
    const ignoredCorrelationIds = [
        'set-reality-check',
        'update-deposit-limit',
        'set-player-timeout'
    ];

    module.exports = {
        notify: function(resp) {
            const { correlationId } = resp.data;

            if (ignoredCorrelationIds.includes(correlationId)) {
                return;
            }

            window.Playtech.API.popup.showPopup({
                title: i18n.t(tKey + '.popupTitle'),
                content: i18n.t(tKey + '.popupContent')
            });
        }
    };
});
